import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-input" }
const _hoisted_2 = { class: "wrapper-label" }
const _hoisted_3 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        class: _normalizeClass(["label-input", { 'label-disabled': _ctx.isDisabled }])
      }, _toDisplayString(_ctx.label), 3)
    ]),
    _createElementVNode("textarea", {
      rows: "10",
      class: _normalizeClass(["input", { disabled: _ctx.isDisabled }]),
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeInput && _ctx.changeInput(...args))),
      value: _ctx.value,
      disabled: _ctx.isDisabled ? 1 : 0,
      autocomplete: "off",
      onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args)))
    }, null, 42, _hoisted_3),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.hasError ? 'error' : 'no-error')
    }, _toDisplayString(_ctx.hasError ? _ctx.error.esMessage : ""), 3)
  ]))
}